module.exports = __webpack_public_path__ + "fonts/Arimo-500-cyrillic-ext9.52a786e.woff2";